import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { CatalogSampleType } from "../models/CatalogSampleType";

export const getCatalogSampleTypes = async (signal?: AbortSignal) => {
  const apiService = new MESApiService();

  return await apiService.callV2("[LAB].[GetCatSampleTypes]", [], signal);
};
export const upsertCatalogSampleType = async (
  sampleType: CatalogSampleType,
) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [
    { name: "Id", value: sampleType.SampleTypeId },
    { name: "Name", value: sampleType.SampleTypeName },
    { name: "Enabled", value: sampleType.IsActive },
  ];

  return await apiService.callV2("[LAB].[UpsertCatSampleType]", parameters);
};
export const getCatalogSampleType = async (SampleTypeId: number | null) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [
    { name: "SampleTypeId", value: SampleTypeId },
  ];

  return await apiService.callV2("[LAB].[GetCatSampleType]", parameters);
};
